import ProductsBtn from "../../../components/sub/ProductsBtn";
import SubTitle from "../../../components/sub/SubTitle";

const ProductsFeatures = () => {
  const productsList = [
    {
      img: "/images/products1.webp",
      txt1: `인체에 무해한 식품첨가물 성분의 용제에<br/>
신나, 톨루엔 대신 물, 알코올을 사용한<br/>
무색, 무취 저자극 세정제로써<br/>
각종 독성 테스트 통과
`,
      txt2: "식품첨가물 배합 세정제",
    },
    {
      img: "/images/products2.webp",
      txt1: `오염에 맞는 제품을 도포한 후 닦아 내는 것만으로<br/>
세정이 되며 연마나 가열의 추가작업이 필요 없는<br/>
효율적인 세정`,
      txt2: "작업의 효율성",
    },
    {
      img: "/images/products3.webp",
      txt1: `찌든 오염, 악성 곰팡이, 녹물에 있는<br/>
각종 세균을 카이노스 Bio 케미칼을 사용하여<br/>
근본적으로 제거하므로<br/>
세정과 동시에 99.9% 살균과 예방이 가능하다.
`,
      txt2: "탁월한 살균력",
    },
  ];

  const certiList = [
    "/images/certi1.webp",
    "/images/certi2.webp",
    "/images/certi3.webp",
    "/images/certi4.webp",
    "/images/certi5.webp",
    "/images/certi6.webp",
    "/images/certi7.webp",
    "/images/certi8.webp",
    "/images/certi9.webp",
    "/images/certi10.webp",
  ];
  return (
    <>
      <SubTitle
        src={"/images/subTitle4.webp"}
        title={"제품소개"}
        eng={"Introduction of item"}
      />
      <ProductsBtn id={0} />
      <div className="relative w-full h-full pt-14 lg:pt-28 xl:pt-36">
        <div
          id="title"
          className="relative w-full h-fit text-center mb-10 xl:mb-14 "
        >
          <h3 className="text-center font-normal">
            카이노스&nbsp;Bio&nbsp;케미칼의 특징&nbsp;및&nbsp;장점
          </h3>
        </div>
        <div className="relative w-full h-fit max-w-[1300px] px-2 mx-auto grid grid-cols-1 lg:grid-cols-3 gap-5 lg:gap-6">
          {productsList.map((v, i) => (
            <div
              key={i}
              data-aos="fade-up"
              className="relative w-full h-full border border-primary btn6 inline-block"
            >
              <div className="relative w-full h-60 lg:h-80 xl:h-96 overflow-hidden">
                <img
                  className="!relative w-full h-full object-cover object-center transition-transform duration-300"
                  alt={`카이노스 바이오케미칼 특징 - ${v.txt2}`}
                  src={v.img}
                  width={414}
                  height={506}
                />
              </div>
              <div className=" relative w-full h-fit my-3 text-center">
                <p className="text-primary text-2xl 2xl:text-3xl pt-3">
                  {v.txt2}
                </p>
                <p
                  className="mt-3"
                  dangerouslySetInnerHTML={{ __html: v.txt1 }}
                ></p>
              </div>
            </div>
          ))}
        </div>
        <div className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36">
          <div
            id="title"
            className="relative w-full h-fit text-center mb-10 xl:mb-14 "
          >
            <h3 className="text-center font-normal">
              맹독성 세제들과 비교했을 시 효과 동일, 환경, 건물, 인체 피해 없음
            </h3>
          </div>
          <div
            data-aos="fade-left"
            className="relative w-full h-full overflow-scroll"
          >
            <img src="/images/productsTable.webp" alt="맹독성 세제와 카이노스 Bio 케미칼 성능 비교표" />
          </div>
        </div>
        <div className="relative w-full h-full max-w-[1200px] px-2 mx-auto pb-14 lg:pb-28 xl:pb-36">
          <div
            id="title"
            className="relative w-full h-fit text-center mb-10 xl:mb-14 "
          >
            <h3 className="text-center font-normal">작업방법 및 순서</h3>
          </div>
          <div data-aos="fade-right">
            <img src="/images/productsProcess.webp" alt="카이노스 Bio 케미칼 작업방법 및 순서 안내" />
          </div>
        </div>
        <div className="relative w-full h-full bg-[url('../public/images/productsBg.webp')] bg-cover bg-center py-14 lg:py-28 xl:py-36">
          <div
            id="title"
            className="relative w-full h-fit text-center mb-10 xl:mb-14  text-white "
          >
            <h3 className="text-center font-normal">Bio Certificate</h3>
          </div>
          <div className=" relative w-full h-full px-[calc((100%-var(--container))/2)] grid grid-cols-2 xl:grid-cols-5">
            {certiList.map((v, i) => (
              <div data-aos="fade-up">
                <img src={v} alt={`카이노스 바이오케미칼 친환경 인증서 ${i + 1}`} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductsFeatures;
